'use client';

import { Loader2, FileJson, Code } from 'lucide-react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { DataTab } from './data-tab';
import { TechnicalTab } from './technical-tab';
import type { ExecutionResult, RequestConfig } from '@/lib/integrations/types';

interface ResponseTabsProps {
  result: ExecutionResult | null;
  requestConfig: RequestConfig | null;
  connectionAlias: string;
  loading?: boolean;
}

export function ResponseTabs({
  result,
  requestConfig,
  connectionAlias,
  loading,
}: ResponseTabsProps) {
  if (loading) {
    return (
      <div className="flex flex-col items-center justify-center h-64 text-muted-foreground">
        <Loader2 className="h-8 w-8 animate-spin mb-4" />
        <p className="text-sm">Executing request...</p>
      </div>
    );
  }

  if (!result || !requestConfig) {
    return (
      <div className="flex flex-col items-center justify-center h-64 text-muted-foreground">
        <FileJson className="h-12 w-12 mb-4 opacity-30" />
        <p className="text-sm">Select an endpoint and execute a request</p>
        <p className="text-xs mt-1">Results will appear here</p>
      </div>
    );
  }

  return (
    <Tabs defaultValue="data" className="w-full">
      <TabsList className="grid w-full max-w-md grid-cols-2">
        <TabsTrigger value="data" className="flex items-center gap-2">
          <FileJson className="h-4 w-4" />
          Data
        </TabsTrigger>
        <TabsTrigger value="technical" className="flex items-center gap-2">
          <Code className="h-4 w-4" />
          Technical
        </TabsTrigger>
      </TabsList>

      <TabsContent value="data" className="mt-4">
        <DataTab result={result} />
      </TabsContent>

      <TabsContent value="technical" className="mt-4">
        <TechnicalTab
          result={result}
          requestConfig={requestConfig}
          connectionAlias={connectionAlias}
        />
      </TabsContent>
    </Tabs>
  );
}

export default ResponseTabs;
